import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../constants/ActionNameConstants';
import { PROOFREADER_DASHBOARD_FILE_COUNT_API_URL } from '../../../../constants/ApiUrlConstants';
import { postApiRequest } from '../../../../features/axiosClient';
import { getUserInfo } from '../../../../utils/UserInfoUtils';
import { dashboardProofreaderFailure, dashboardProofreaderSuccess } from '../actions';

const dashboardProofreaderAPI = async () => {
  try {
    const userId = getUserInfo()?.UserId;
    const data = await postApiRequest(`${PROOFREADER_DASHBOARD_FILE_COUNT_API_URL}?UserId=${userId}`);
    return data;
  } catch (error) {
    throw error;
  }
};

function* handleDashboardProofreader() {
  try {
    const response = yield call(dashboardProofreaderAPI);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(dashboardProofreaderSuccess(response));
  } catch (error) {
    yield put(dashboardProofreaderFailure(error));
  }
}

export function* watchProofreaderDashboard() {
  yield takeLatest(types.GET_PROOFREADER_DASHBOARD_REQUEST, handleDashboardProofreader);
}
